import { render } from "./ProductCart.vue?vue&type=template&id=5639f587&scoped=true"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"

import "./ProductCart.vue?vue&type=style&index=0&id=5639f587&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5639f587"

export default script